define(
	'CustomConversionTracking'
,   [
		
	]
,   function (
		
	)
{
	'use strict';

    function addScriptOnce() {
        var SCRIPT_ID = 'custom-tracking-script';

        // Prevent duplicate injection
        if (document.getElementById(SCRIPT_ID)) {
            return;
        }

        var script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.type = 'text/javascript';
        script.async = true;

        // Inline JS
        script.text = `
                (function(w,d,t,r,u)
                {
                    var f,n,i;
                    w[u]=w[u]||[],f=function()
                    {
                    var o={ti:"343226933", enableAutoSpaTracking: true};
                    o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")
                    },
                    n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function()
                    {
                    var s=this.readyState;
                    s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)
                    },
                    i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)
                })
                (window,document,"script","//bat.bing.com/bat.js","uetq");

            <!--You can set default Consent Mode right after the UET tag-->

                window.uetq=window.uetq||[];
                window.uetq.push('consent', 'default', {
                    'ad_storage': 'denied',
                });

                <!--Update consent based on user choice.-->
                <!--Implement a cookie banner or another method to collect user consent.-->
                <!--When a user grants consent (e.g., selects 'Accept' on your banner), update the consent settings using the command below.-->

                window.uetq=window.uetq||[];
                window.uetq.push('consent', 'update', {
                    'ad_storage': 'granted',
                });

        `;

        document.head.appendChild(script);
    }

	return  {
		mountToApp: function mountToApp (container)
		{
			addScriptOnce();
		}
	};
});
